module.exports = __webpack_public_path__ + "static/img/contact_page top img_desktop.cbd14644.jpg";